import Step from "./Step";

class Step3 extends Step {
    constructor() {
        super(3, 'company', $(`[data-register-step="company"]`));
        this.form = null;
        this.validator = null;
        this.submitButton = null;
    }

    init() {
        // Get form elements
        this.form = document.querySelector('#company_info_form');
        this.submitButton = document.querySelector('#company_info_button');

        // Initialize validation
        this.initValidation();

        // Bind form submit event
        this.handleSubmit();

        // Pre-fill form if data exists
        this.populateForm();
    }
    initValidation() {
        // Define validation rules
        this.validator = FormValidation.formValidation(this.form, {
            fields: {
                company_name: {
                    validators: {
                        notEmpty: {
                            message: 'Bedrijfsnaam is verplicht'
                        },
                        stringLength: {
                            min: 2,
                            max: 100,
                            message: 'Bedrijfsnaam moet tussen 2 en 100 karakters zijn'
                        },
                        regexp: {
                            regexp: /^[a-zA-Z0-9\s\-&.,()]+$/,
                            message: 'Bedrijfsnaam mag alleen letters, cijfers en gangbare leestekens bevatten'
                        }
                    }
                },
                phone: {
                    validators: {
                        notEmpty: {
                            message: 'Telefoonnummer is verplicht'
                        },
                        phone: {
                            country: 'NL',
                            message: 'Voer een geldig Nederlands telefoonnummer in'
                        },
                        regexp: {
                            regexp: /^[+]?[0-9\s\-()]{8,15}$/,
                            message: 'Telefoonnummer heeft een ongeldig formaat'
                        }
                    }
                }
            },
            plugins: {
                trigger: new FormValidation.plugins.Trigger(),
                bootstrap: new FormValidationBootstrap5({
                    rowSelector: '.fv-row'
                })
            }
        });
    }

    handleSubmit() {
        // Handle button click
        this.submitButton.addEventListener('click', (e) => {
            e.preventDefault();

            // Show loading state
            this.submitButton.setAttribute('data-kt-indicator', 'on');
            this.submitButton.disabled = true;

            // Validate form
            if (this.validator) {
                this.validator.validate().then((status) => {
                    if (status === 'Valid') {
                        // Save form data locally
                        this.saveFormData();

                        // Save to server
                        this.saveStepProgress().then(() => {
                            // Proceed to next step
                            setTimeout(() => {
                                register.goNext();
                            }, 500);
                        }).catch((error) => {
                            console.error('Error saving step progress:', error);
                            // Still proceed to next step even if save fails
                            setTimeout(() => {
                                register.goNext();
                            }, 500);
                        });
                    } else {
                        // Hide loading state
                        this.submitButton.removeAttribute('data-kt-indicator');
                        this.submitButton.disabled = false;
                    }
                });
            }
        });
    }

    saveFormData() {
        // Get form data
        const formData = new FormData(this.form);

        // Save to global register data (both window.register and register references)
        if (!window.register.companyData) {
            window.register.companyData = {};
        }

        window.register.companyData.company_name = formData.get('company_name');
        window.register.companyData.phone = formData.get('phone');

        // Also ensure register.companyData is updated (for consistency with Step4)
        if (typeof register !== 'undefined') {
            if (!register.companyData) {
                register.companyData = {};
            }
            register.companyData.company_name = formData.get('company_name');
            register.companyData.phone = formData.get('phone');
        }

        console.log('Company data saved:', window.register.companyData);
    }

    populateForm() {
        // Pre-fill form if data exists
        if (window.register.companyData) {
            if (window.register.companyData.company_name) {
                this.form.querySelector('[name="company_name"]').value = window.register.companyData.company_name;
            }
        }

        // Pre-fill phone from authUser as priority
        if (window.register.authUser && window.register.authUser.phone) {
            this.form.querySelector('[name="phone"]').value = window.register.authUser.phone;
        } else if (window.register.companyData && window.register.companyData.phone) {
            // Fallback to companyData if not yet in authUser
            this.form.querySelector('[name="phone"]').value = window.register.companyData.phone;
        }
    }

    async saveStepProgress() {
        const formData = new FormData(this.form);
        const stepData = {
            company_name: formData.get('company_name'),
            phone: formData.get('phone')
        };

        try {
            const response = await API.post('/register/saveStep', {
                step: 3,
                data: stepData
            });

            if (response.status !== 200) {
                throw new Error('Failed to save step progress');
            }

            return response;
        } catch (error) {
            console.error('Error saving step 3 progress:', error);
            throw error;
        }
    }

    isComplete() {
        if (!this.form) return false;

        const companyName = this.form.querySelector('[name="company_name"]').value.trim();
        const phone = this.form.querySelector('[name="phone"]').value.trim();

        return companyName.length >= 2 && phone.length >= 8;
    }
}

export default Step3;